import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SpaceXs, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { CustomSingleSkeleton } from "../CustomSingleSkeleton/CustomSingleSkeleton.js";
import { COMPONENT_NAME, NUMBERED_STEP_TITLE_HEIGHT, NUMBERED_STEP_CIRCLE_ID, BORDER_RADIUS_CIRCLE, NUMBERED_STEP_TITLE_ID, NUMBERED_STEP_DESCRIPTION_HEIGHT, NUMBERED_STEP_DESCRIPTION_ID } from "../constants.js";
import { SkeletonVariant } from "../enums.js";
const NumberedStepSkeleton = ({
  hiddenText,
  width
}) => {
  const widthValue = width ?? "100%";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        gap: SpaceXs,
        width: widthValue
      },
      "data-testid": COMPONENT_NAME,
      children: [
        /* @__PURE__ */ jsx(
          CustomSingleSkeleton,
          {
            "data-testid": NUMBERED_STEP_CIRCLE_ID,
            height: NUMBERED_STEP_TITLE_HEIGHT,
            hiddenText,
            sx: { flex: "none" },
            variant: SkeletonVariant.Circular,
            width: NUMBERED_STEP_TITLE_HEIGHT
          }
        ),
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              flexDirection: "column",
              gap: SpaceXxs,
              width: "100%"
            },
            children: [
              /* @__PURE__ */ jsx(
                CustomSingleSkeleton,
                {
                  "data-testid": NUMBERED_STEP_TITLE_ID,
                  height: NUMBERED_STEP_TITLE_HEIGHT,
                  hiddenText,
                  sx: {
                    borderRadius: BORDER_RADIUS_CIRCLE
                  },
                  variant: SkeletonVariant.Rectangular
                }
              ),
              /* @__PURE__ */ jsx(
                CustomSingleSkeleton,
                {
                  "data-testid": NUMBERED_STEP_DESCRIPTION_ID,
                  height: NUMBERED_STEP_DESCRIPTION_HEIGHT,
                  hiddenText,
                  sx: {
                    borderRadius: BORDER_RADIUS_CIRCLE
                  },
                  variant: SkeletonVariant.Rectangular
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  NumberedStepSkeleton
};
